import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class TransactionType extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;
}
